<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 sm11 md11 lg11>
            <h2 v-if="$vuetify.breakpoint.lgAndUp">
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >รายละเอียดประกาศ
            </h2>
            <h3 v-else>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >รายละเอียดประกาศ
            </h3>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 sm11 md11 lg11 pt-5>
            <v-card class="rounded-lg">
              <v-card-text>
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11>
                    <div class="pb-2 text-center">
                      <p>
                        {{ BusinessNameTh }}
                      </p>
                      <p>{{ BusinessNameEng }}</p>

                      <hr style="border-top: 1px solid" />
                      <p class="pb-2 pt-5">
                        <b style="font-size: 22px">ประกาศ </b>
                      </p>
                      <p>{{ AnnounceNo }}</p>
                      <p><b>เรื่อง </b> {{ PolicyHeader }}</p>

                      <hr style="border-top: 1px dashed" />

                      <div class="pt-4" v-html="PolicyDetail"></div>
                      <v-layout
                        row
                        wrap
                        justify-center
                        align-center
                        pt-4
                        pb-7
                        v-if="SendStatus === 'WAIT' || SendStatus === 'Read'"
                      >
                        <v-flex xs4 sm4 md2 lg2>
                          <v-btn color="#077893" dark block @click="Fn_Save">
                            รับทราบ
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-layout
                        row
                        wrap
                        justify-center
                        align-self-center
                        pb-4
                        v-else
                      >
                        <v-flex xs11 sm11 md4 lg4 pt-4>
                          <v-alert border="left" dense text type="success">
                            รับทราบประกาศเรียบร้อยแล้ว
                          </v-alert>
                          <p><b>วันที่ </b> {{ DataConsent.UpdateAt }}</p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogGeneralConsent
        :show="DialogGeneral"
        :_header="PolicyHeader"
        :_detail="PolicyDetail"
        @closeDialogDelete="DialogGeneral = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import DialogGeneralConsent from "@/components/dialog/DialogGeneralConsentDetail.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogGeneralConsent, OverlaySearch },
  data: function () {
    return {
      AnnounceName: "",
      DataConsent: [],
      PolicyHeader: "",
      PolicyDetail: "",
      BusinessNameTh: "",
      BusinessNameEng: "",
      AnnounceNo: "",
      SendStatus: "",
      loadingDownloadData: false,
      DialogGeneral: false,
    };
  },
  computed: {
    ...mapGetters(["DataGroupConsentOnechat"]),
    ...mapGetters(["DataGroupConsentOnechatPath"]),
    ...mapGetters(["Business"]),
    _SendId: {
      get() {
        return this.DataGroupConsentOnechat || "-";
      },
    },
    _PathHistory: {
      get() {
        return this.DataGroupConsentOnechatPath || "-";
      },
    },
  },
  mounted() {
    this.Fn_getDataAnnounce();
  },
  methods: {
    async Fn_getDataAnnounce() {
      this.loadingDownloadData = true;
      var payload = {
        AccessToken: this.$cookies.get("ChatAccessToken"),
        AnnounceId: this._SendId.AnnounceId,
      };
      var Headers = {
        AccountId: this.$cookies.get("ChatAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/CheckAnnounce",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.DataConsent = response.data.Message;
            this.AnnounceName = response.data.Message.AnnounceName;
            this.AnnounceNo = response.data.Message.AnnounceNo;
            this.PolicyHeader = response.data.Message.PolicyHeader;
            this.SendStatus = response.data.Message.SendStatus;
            this.PolicyDetail = response.data.Message.PolicyDetail;

            this.BusinessNameTh = response.data.Message.BusinessNameTh;
            this.BusinessNameEng = response.data.Message.BusinessNameEng;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_Save() {
      var payload = {
        AccessToken: this.$cookies.get("ChatAccessToken"),
        AccountId: this.DataConsent.AccountId,
        AnnounceId: this.DataConsent.AnnounceId,
      };
      var Headers = {
        AccountId: this.$cookies.get("ChatAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/ConfirmAnnounce",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            Toast.fire({
              icon: "success",
              title: this.$i18n.t("alert.confirm"),
            });
            this.Fn_getDataAnnounce();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_BackIndex() {
      this.$router.push({ path: this._PathHistory });
    },
    Fn_DetailPolicy() {
      this.DialogGeneral = true;
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.bg-card {
  background-color: #eeeeee;
}
</style>
